import { unescape } from 'html-escaper/esm'

// 处理JSON.parse无法处理long类型数据的问题
const LosslessJSON = require('lossless-json')

// JSON 解析处理
function jsonConvert(key, value) {
    // 超长的losslessNumber转为字符串，否则还原为数字
    if (value && value.isLosslessNumber) {
        try {
            return value.valueOf()
        } catch (e) {
            // 上溢出或者数位被截取，返回字符串描述
            if (e.message.indexOf("truncated") >= 0 || e.message.indexOf("overflow") >= 0) {
                return value.value
            }
            // 下溢返回0
            if (e.message.indexOf("underflow") >= 0) {
                return 0
            }
        }
    } else {
        // htmlDecode
        if (typeof value === "string" && value.indexOf("&quot;") >= 0) {
            return unescape(value)
        }

        return value;
    }
}

if (window.JSON) {
    window.JSON.parse = function(str) {
        return LosslessJSON.parse(str, jsonConvert)
    }
}

// 处理JSON.parse抛异常的问题
if (window.JSON) {
    window.JSON.safeParse = function(str) {
        try {
            var result = window.JSON.parse(str)

            return typeof result == "object" ? result : false
        } catch (e) {
            return false
        }
    }
}

// dom
if (!Element.prototype.matches) {
	// support IE9+
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector
}

// extend
if (typeof Array.prototype.groupBy == "undefined") {
    Array.prototype.groupBy = function(iteratee) {
        if (typeof iteratee == "string") {
            var _id = iteratee

            iteratee = function(e) {
                return e[_id]
            }
        }

        if (typeof iteratee != "function") {
            throw new TypeError("groupBy iteratee`s type must be String or Functiom")
        }

        var groups = {},
            key = ''

        this.forEach(v => {
            key = iteratee(v)
            groups[key] ? groups[key].push(v) : (groups[key] = [v])
        })

        return groups
    }
}